"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoutes = void 0;
const route_1 = require("../route");
class UserRoutes extends route_1.Route {
    constructor() {
        super('users');
    }
    getAllUsers() {
        return this.get('/');
    }
    getUser(userId = 'me') {
        return this.get(`/${userId}`);
    }
    getCurrentUser() {
        return this.get(`/me`);
    }
    getUserStatus() {
        return this.get('/status');
    }
    getBalance() {
        return this.get('/balance');
    }
    getAssetBalance(asset) {
        return this.get(`/balance/${asset}`);
    }
    getSuggestions() {
        return this.get('/suggestions');
    }
    getFeed(count = 100, after = new Date(), id) {
        return this.get('/feed', { count, after, id });
    }
    editUser(firstName, lastName, avatar) {
        return this.put('/me', { firstName, lastName, avatar });
    }
    createUser(firstName, lastName, pin, currency, inviteCode, deviceId, dateOfBirth, address, cityOfBirth, countryOfBirth, nationality, gender) {
        return this.post('/', { firstName, lastName, pin, currency, inviteCode, deviceId, dateOfBirth, address, cityOfBirth, countryOfBirth, nationality, gender });
    }
    computeMatchingIdentifiers(identifiers, namedIdentifiers, contactsHash) {
        return this.post('/matching', { identifiers, namedIdentifiers, contactsHash });
    }
    addDeviceId(deviceId) {
        return this.post('/device', { deviceId });
    }
    updateTag(tag) {
        return this.put('/tag', { tag });
    }
    isTagAvailable(tag) {
        return this.get(`/tag/available/${tag}`);
    }
    search(term) {
        return this.get(`/search/${encodeURIComponent(term)}`);
    }
    combineAccounts(secondaryUserId) {
        return this.post('/combine', { secondaryUserId });
    }
    fetchNuban() {
        return this.get('/nuban/details');
    }
    enableNuban() {
        return this.post('/nuban/enable');
    }
    fetchEuAccountNumber() {
        return this.get('/railsbank/details');
    }
    sendComplianceEvent(eventName, linkedAccountId) {
        return this.post('/events', { eventName, linkedAccountId });
    }
    getDevices() {
        return this.get('/devices/all');
    }
    unlinkDevice(deviceId) {
        return this.post('/devices/unlink', { deviceId });
    }
    checkPreonboarding(params) {
        return this.get('/preonboarding', params);
    }
    getUserAccountConfig() {
        return this.get('/accounts/configuration', {});
    }
}
exports.UserRoutes = UserRoutes;
//# sourceMappingURL=users.js.map